import { parseInt } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { allowPresection } from 'src/services/ClientApi'
import { sideBarSections } from 'src/services/ContentApi'
import { clientSections } from 'src/store/actions/sectionActions'
import { changeSidenav } from 'src/store/actions/sidenavAction'
import { changeTitle } from 'src/store/actions/titleActions'
import Loader from './Loader'
import {
  getCurrentSectionNo,
  getIsCompleted,
  getIsFaceSheetCompleted,
  getIsPreSectionCompleted,
  getMapType,
} from 'src/lib/core'

const Sidebar = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { state } = useLocation()
  const language = useSelector((state) => state.language)
  const clientSectionData = useSelector((state) => state.clientSections)
  const [menuSection, setMenuSection] = useState([])
  const [startPage, setStartPage] = useState([])
  const sidenav = useSelector((state) => state.sidenav)
  const title = useSelector((state) => state.title)
  const [loader, setLoader] = useState(false)
  const isClientPreSection = useSelector((state) => state.isClientPreSection)
  const { txt_Intakemenu, txt_Facesheet, txt_pretrialrelease, txt_messages } = useSelector(
    (state) => state.generalData,
  )

  const handleClose = (sidenav) => {
    if (sidenav) {
      document.body.classList.add('open')
    } else {
      document.body.classList.remove('open')
    }
  }
  const sections = async () => {
    setLoader(true)
    const [sectionData, isPreSection] = await Promise.all([
      sideBarSections(getMapType.get(), language),
      allowPresection(),
    ])
    dispatch(clientSections(language))
    dispatch({
      type: 'SET_CLIENT_PRESECTION',
      payload: isPreSection?.data?.allowPresection,
    })
    setMenuSection(sectionData)
    setLoader(false)
  }
  const handlePage = (sectionNo) => {
    const section = startPage.find((no) => no.sectionNo == sectionNo)
    navigate(`/client/intake/${section.startPageNo}`, { state })
    dispatch(
      changeTitle({
        sectionname: title.sectionname,
        currentSectionid: section.sectionNo,
      }),
    )
  }
  const gotoPage = (pageNo) => {
    let sectionName
    if (pageNo === -2) {
      navigate(`/client/facesheet/1`)
      sectionName = 'facesheet'
    } else if (pageNo === -3) {
      navigate(`/client/messages`)
      sectionName = 'messages'
    } else {
      navigate(`/client/presection/1`)
      sectionName = 'presection'
    }
    dispatch(
      changeTitle({
        sectionname: sectionName,
        currentSectionid: pageNo,
      }),
    )
  }
  useEffect(() => {
    sections()
  }, [language])
  useEffect(() => {
    if (clientSectionData) {
      setStartPage(clientSectionData)
      window.sessionStorage.setItem(
        'endPage',
        clientSectionData[clientSectionData?.length - 1]?.endPageNo || 0,
      )
    }
  }, [clientSectionData])
  useEffect(() => {
    handleClose(sidenav)
  }, [sidenav])
  return (
    <div className={`sidenav ${sidenav ? '' : 'collapsed'}`} id="sidebar">
      <div className="section-index scrol lable">
        <h3>
          {txt_Intakemenu}
          <span
            className="sidenav-close"
            onClick={() => dispatch(changeSidenav(false))}
            aria-label="Close"
          ></span>
        </h3>
        <div className="section-index-wrap">
          {loader ? (
            <Loader />
          ) : (
            <div className="custom-scrollbar">
              {getIsCompleted.get() && (
                <div
                  className={`complete ${-3 === parseInt(title.currentSectionid) ? 'complete-active' : ''}`}
                >
                  <button
                    className="process-step-icon"
                    onClick={() => gotoPage(-3)}
                    style={{ paddingLeft: 20 }}
                  >
                    <b>{txt_messages}</b>
                  </button>
                </div>
              )}
              <div
                className={`complete ${-2 === parseInt(title.currentSectionid) ? 'complete-active' : ''}`}
              >
                <button
                  className="process-step-icon"
                  onClick={() => gotoPage(-2)}
                  style={{ paddingLeft: 20 }}
                >
                  {txt_Facesheet}
                </button>
              </div>
              {isClientPreSection && (
                <div
                  className={`${getIsFaceSheetCompleted.get() ? (getIsPreSectionCompleted.get() ? `complete ${-1 === parseInt(title.currentSectionid) ? 'complete-active' : ''}` : 'inprogress') : 'disabled'}`}
                >
                  <button
                    className="process-step-icon"
                    onClick={() => gotoPage(-1)}
                    style={{ paddingLeft: 20 }}
                  >
                    {txt_pretrialrelease}
                  </button>
                </div>
              )}
              {menuSection?.map((section, index) => {
                let className = 'disabled'
                const sectionId = parseInt(getCurrentSectionNo.get())
                const isCompleted = getIsCompleted.get()
                const currentSectionId = parseInt(title.currentSectionid)
                const sectionNo = parseInt(section.recordid)
                if (sectionNo === sectionId && !isCompleted) {
                  className = 'inprogress'
                } else if (sectionNo === currentSectionId) {
                  className = 'complete complete-active'
                } else if (sectionNo < sectionId || isCompleted) {
                  className = 'complete'
                }

                return (
                  <div className={className} key={index}>
                    {className === 'disabled' ? (
                      <button className="process-step-icon">
                        <span className="ord-no">{section.recordid}.</span>
                        <span className="title">
                          {section.txt_section_short_name || section.txt_sectionname}
                        </span>
                      </button>
                    ) : (
                      <button
                        className="process-step-icon"
                        onClick={() => handlePage(section.recordid)}
                      >
                        <span className="ord-no">{section.recordid}.</span>
                        <span className="title">
                          {section.txt_section_short_name || section.txt_sectionname}
                        </span>
                      </button>
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Sidebar
